import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class WalletApi extends CrudBase {

  getWalletInfo = (representanteId, params) => axios.get(`${this.endpoint}/get-by?representativeId=${representanteId}`, params)

  defaultMethods = {
    ...this.defaultMethods,
    getWalletInfo: this.getWalletInfo,
  }
}

const wallet = new WalletApi('api/v1/wallet-info');

export default wallet.defaultMethods;

